<template>
  <v-row no-gutters>
    <v-col cols="12" sm="10" offset-sm="1">
      <span class="headline">Dokumenta</span>
      <bit-page :breadcrumbs="breadcrumbs"></bit-page>
      <v-row class="white mt-3 pa-3">
        <v-col cols="6">
          <v-data-table
            :headers="headers"
            :items="forms"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.action="{ item }">
              <v-btn small color="primary" @click="show = item.fields">
                prikazi
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="6">
          <template v-for="(item, index) in show">
            <div>{{capitalizeFirstLetter(index)}}: {{item}}</div>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import bitPage from "../../components/layout/page";
import config from "../../config";

export default {
  components: {
    bitPage
  },
  head() {
    return {
      title: 'BitLab CMS'
    }
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Forme',
        disabled: true
      }
    ],
    headers: [
      {
        text: 'Datum',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: '',
        align: 'end',
        sortable: false,
        value: 'action',
      }
    ],
    forms: [],
    show: null
  }),
  created() {
    this.axios.get(`/form`).then(res => {
      this.forms = res.data
    })
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
}
</script>
